import {Button, Form, FormControl} from "react-bootstrap";
import SchedulerActionLabel from "./SchedulerActionLabel";
import "./Scheduler.css";

export default function SchedulerToolbar({
    isLoading,
    regionSelector,
    onDateOffset,
    onDateSelect,
    onRefresh,
    onSearchTextChange,
    searchText,
    selectedDate,
    statusControls,
}) {
    return (
        <div className="scheduler-toolbar mb-2">
            {statusControls ? (
                <div className="scheduler-toolbar-status">
                    {statusControls}
                </div>
            ) : null}
            <div className="scheduler-toolbar-date-column">
                <div className="scheduler-toolbar-date-controls">
                    <Button
                        disabled={isLoading}
                        variant="outline-secondary"
                        aria-label="Previous day"
                        onClick={() => onDateOffset(-1)}
                    >
                        {"<"}
                    </Button>
                    <Form.Control
                        disabled={isLoading}
                        className="scheduler-toolbar-date-input"
                        type="date"
                        name="date"
                        aria-label="Scheduler date"
                        onChange={(event) => onDateSelect(event.target.value)}
                        value={selectedDate}
                    />
                    <Button
                        disabled={isLoading}
                        variant="outline-secondary"
                        aria-label="Next day"
                        onClick={() => onDateOffset(1)}
                    >
                        {">"}
                    </Button>
                    <Button
                        disabled={isLoading}
                        variant="outline-secondary"
                        onClick={() => onDateOffset(0)}
                    >
                        Today
                    </Button>
                    {regionSelector}
                    <Button
                        className="scheduler-toolbar-refresh"
                        variant="secondary"
                        disabled={isLoading}
                        aria-busy={isLoading}
                        onClick={onRefresh}
                    >
                        <SchedulerActionLabel isLoading={isLoading}>Refresh</SchedulerActionLabel>
                    </Button>
                </div>
            </div>
            <div className="scheduler-toolbar-search-column">
                <FormControl
                    disabled={isLoading}
                    value={searchText}
                    onChange={(event) => onSearchTextChange(event.target.value)}
                    type="search"
                    placeholder="Enter Filter Text..."
                    aria-label="Search"
                />
            </div>
        </div>
    );
}
